export default __webpack_public_path__ + "static/media/user.f8f6c3b8.svg";